import React from 'react';
import ServiceItem from './service-item'

//https://reactjs.org/docs/lists-and-keys.html
class ServicesList extends React.Component {
	render() {
		return (
		<ul className="services__list services__list--home grid--services" >
	      {this.props.data.map((item, index) =>
	          <ServiceItem 
					key={item.ID} 
					index = {index}
					title={item.post_title} 
					url={item.link}
					original_name={item.custom_meta_fields.original_name} 
					duration={item.custom_meta_fields.duration} 
					desc={item.custom_meta_fields.desc}  
					cover={item.custom_meta_fields.cover}  
	          		/>
	        )}
		</ul>
		);
	}
}	

export default ServicesList;